import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import { DateHelper, StringHelper } from "@/utils"
const defaultersSubscription = async (
  params: DefaultersSearchParams
) => {
  const newParams = {
    ...params,
    document: StringHelper.onlyAlphanumeric(
      params.document
    ),
    startDateTime: DateHelper.formatToISO(
      params.startDateTime
    ),
    endDateTime: DateHelper.formatToISO(params.endDateTime),
  }
  const queryString =
    StringHelper.objectToQueryString(newParams)
  const url = `${ENDPOINTS.DEFAULTER_SUBSCRIPTION}?${queryString}`
  const { data } =
    await api.get<DefaultersSubscriptionResponseType>(url)
  return data
}
const useDefaultersSubscription = (
  params: DefaultersSearchParams,
  enabled = false
) => {
  const response = useQuery({
    queryKey: [ENDPOINTS.DEFAULTER_SUBSCRIPTION, params],
    queryFn: async () => defaultersSubscription(params),
    enabled,
  })
  return response
}
export default useDefaultersSubscription
